
import { defineComponent, PropType } from 'vue'
import CookiesCoreMixinVue from '@/modules/CookiesCoreMixin.vue'

export default defineComponent({
  mixins: [CookiesCoreMixinVue],
  props: {
    Search: { type: String, default: '' },
    ParentThis: { type: Object as PropType<any> }
  },
  mounted () {
    this.ReadCookiesData()
    this.ChangeTableButtons(this.ParentThis, this.Buttons)
    this.ChangeFilter(this.ParentThis, undefined)
  },
  data () {
    return {
      Loading: [] as Array<string>,
      CookiesData: [] as Array<Branch>,
      MappedCData: {} as any,
      Profiles: [] as Array<Profile>
    }
  },
  computed: {
    Filter () :FilterObject {
      return {}
    },
    Buttons () :Array<FunctionalTableButton> {
      return [
        {
          Name: 'New Vendor',
          this: this,
          Function: 'NewVendor',
          Icon: 'Add',
          Visible: this.Access('Purchase_Vendors_Create')
        }
      ]
    },
    TableSettings () :FunctionalTable {
      return {
        DefaultSort: { Direction: -1, Path: 'ID' },
        Fields: [
          {
            Type: 'Index'
          },
          {
            Type: 'Normal',
            Name: 'Serial',
            Bold: true,
            Path: ['ID'],
            Sort: ['ID'],
            Hash: '#',
            IsSearchable: true
          },
          {
            Type: 'DateTime',
            Name: 'Date',
            Path: 'AddedDate',
            Sort: 'AddedDate'
          },
          {
            Type: 'Normal',
            Name: 'Name',
            Path: ['Name'],
            Sort: ['Name'],
            Bold: true,
            Class: 'F1_25em Pointer',
            IsSearchable: true,
            Emits: 'OpenVendor'
          },
          {
            Type: 'Normal',
            Name: 'Notes',
            Path: ['Description'],
            Sort: ['Description'],
            MultiLine: true,
            IsSearchable: true
          },
          {
            Type: 'Normal',
            Name: 'Phone Number',
            Path: ['PhoneNumber'],
            Sort: ['PhoneNumber'],
            IsSearchable: true
          },
          {
            Type: 'Normal',
            Name: 'Remaining',
            Path: ['Total'],
            Sort: ['Total'],
            Bold: true,
            Class: 'F1_25em',
            Unit: this.PriceUnit,
            IsSearchable: true
          },
          {
            Type: 'ActionIcons',
            ActionIcons: [
              {
                ID: 'Expand',
                Visible: this.Access('Purchase_Vendors_Read'),
                TooltTip: this.Translate('Details'),
                Emits: 'OpenVendor'
              },
              {
                ID: 'Phone',
                Visible: this.Access('Purchase_Vendors_Read'),
                TooltTip: this.Translate('Call'),
                Link: 'PhoneCall'
              },
              {
                ID: 'Whatsapp',
                Visible: this.Access('Purchase_Vendors_Read'),
                TooltTip: this.Translate('Open Whatsapp'),
                Emits: 'Whatsapp'
              },
              {
                ID: 'Edit',
                Visible: this.Access('Purchase_Vendors_Edit'),
                TooltTip: this.Translate('Edit'),
                Emits: 'EditVendor',
                DynamicVisiblity: {
                  Operator: 'EQUAL',
                  FixedValue: false,
                  ValuePath: 'IsNew'
                }
              },
              {
                ID: 'Delete',
                Emits: 'DeleteBranch',
                Visible: this.Access('Purchase_Vendors_Remove'),
                TooltTip: this.Translate('Remove'),
                DynamicVisiblity: {
                  Operator: 'EQUAL',
                  FixedValue: false,
                  ValuePath: 'IsNew'
                }
              },
              {
                ID: 'Edit',
                Visible: this.Access('Purchase_Vendors_Create'),
                TooltTip: this.Translate('Edit'),
                Emits: 'EditVendor',
                DynamicVisiblity: {
                  Operator: 'EQUAL',
                  FixedValue: true,
                  ValuePath: 'IsNew'
                }
              },
              {
                ID: 'Delete',
                Visible: this.Access('Purchase_Vendors_Create'),
                Emits: 'DeleteBranch',
                TooltTip: this.Translate('Remove'),
                DynamicVisiblity: {
                  Operator: 'EQUAL',
                  FixedValue: true,
                  ValuePath: 'IsNew'
                }
              }
            ]
          }
        ]
      }
    },
    FilteredData () {
      return this.CookiesFilter(this.ModifiedData, this.Filter, this.Search)
    },
    ModifiedData () {
      var DateSpan = new Date(new Date(this.MEMRead('CurrentNetTime')).getTime() - (60 * 60 * 24 * 1000))
      return this.CookiesData.map((value) => {
        return {
          ...value,
          Total: this.MappedCData['c' + value.ID],
          IsNew: new Date(value.AddedDate) > DateSpan
        }
      })
    }
  },
  methods: {
    ReadCookiesData () {
      fetch('https://timeapi.io/api/Time/current/zone?timeZone=Europe/Amsterdam').then(response => response.json())
        .then(data => {
          // Handle the data received from the API
          this.MEMWrite('CurrentNetTime', data?.dateTime)
        })
        .catch(error => {
          // Handle any errors that occurred during the fetch
          console.error(error)
        })
      this.MappedCData = {}
      this.Loading.push('Loading') // Add Loading flag
      this.Get('Purchase_Vendors', '?Type=v').then(response => {
        this.CookiesData = response.map((value: any) => { return { ...value, PhoneCall: 'tel:' + value.PhoneNumber } })
        this.Loading.pop() // Remove Loading flag
      }, error => {
        this.Loading.pop() // Remove Loading flag
        error.CookiesError = 'Error in reading Branches'
        this.OpenDialog('Error_Dialog', 'Error', error) // [ Dialog Component Name, Dialog Header Text, Dialog Data tot pass ]
      })
      this.ReadOrders()
      this.ReadTransactions()
    },
    ReadOrders () {
      this.Loading.push('Loading') // Add Loading flag
      this.Get('Purchase_Orders').then(response => {
        response.forEach((value: any) => {
          if (!this.MappedCData['c' + value.CustomerID]) this.MappedCData['c' + value.CustomerID] = 0
          this.MappedCData['c' + value.CustomerID] += (value.Price * value.Quantity + value.AddedCost + value.Discount)
        })
        this.Loading.pop() // Remove Loading flag
      }, error => {
        this.Loading.pop() // Remove Loading flag
        error.CookiesError = 'Error in reading Branches'
        this.OpenDialog('Error_Dialog', 'Error', error) // [ Dialog Component Name, Dialog Header Text, Dialog Data tot pass ]
      })
    },
    ReadTransactions () {
      this.Loading.push('Loading') // Add Loading flag
      this.Get('Finance_Transactions').then(response => {
        response.forEach((value: any) => {
          if (!this.MappedCData['c' + value.CustomerID]) this.MappedCData['c' + value.CustomerID] = 0
          this.MappedCData['c' + value.CustomerID] -= (typeof value.Value === 'string' ? parseFloat(value.Value) : value.Value)
        })
        this.Loading.pop() // Remove Loading flag
      }, error => {
        this.Loading.pop() // Remove Loading flag
        error.CookiesError = 'Error in reading Branches'
        this.OpenDialog('Error_Dialog', 'Error', error) // [ Dialog Component Name, Dialog Header Text, Dialog Data tot pass ]
      })
    },
    EditVendor (Vendor: any) {
      this.OpenDialog('Purchase_Vendor_Dialog', this.Translate('Edit Vendor') + ' (' + Vendor.Name + ')', { Data: Vendor, Editing: true }, {})
    },
    DeleteBranch (Branch: any) {
      this.OpenDialog('General_Accept_Dialog', 'Delete', { PostMethod: 'DELETE', PostAPI: 'Purchase_Vendors', AddQuery: '?ID=' + Branch.ID, Text: 'Are you sure you want to delete <strong>' + Branch.Name + '</strong>', ButtonClass: 'BGRed', ButtonText: this.Translate('Delete'), AfterDialogFunction: this.BranchDeleted, AfterDialogFunctionValue: Branch.ImgUrl } as GeneralAcceptDialogData, {})
    },
    BranchDeleted (ImgUrl :string) {
      if (ImgUrl) this.DeleteImage(ImgUrl)
    },
    OpenVendor (Vendor :any) {
      this.OpenDialog('Purchase_VendorView_Dialog', this.Translate('View Vendor'), { Data: { VendorID: Vendor.ID } })
    },
    ButtonsFunctions (button :string) {
      switch (button) {
        case 'NewVendor':
          this.OpenDialog('Purchase_Vendor_Dialog', this.Translate('New Vendor'), {})
          break
      }
    },
    ViewLocation (Branch :Branch) {
      window.open('https://www.google.com/maps/@' + Branch.GPSLongitude + ',' + Branch.GPSLatitude)
    },
    Whatsapp (Vendor: any) {
      this.OpenWhatsapp(Vendor.PhoneNumber)
    }
  },
  watch: {
    CurrentDialogs: function (newVal, oldVal) { // watch it
      if (newVal < oldVal) {
        this.ReadCookiesData()
      }
    },
    Filter: function (newVal, oldVal) { // watch it
      this.ChangeFilter(this.ParentThis, this.Filter)
    },
    Buttons: function (newVal, oldVal) { // watch it
      this.ChangeTableButtons(this.ParentThis, this.Buttons)
    }
  }
})
